import AccountConfigRepository from '../model/AccountConfigRepository'
import moment from 'moment'

class LocalizationVuePlugin {
  static install (Vue, options) {
    let config = new AccountConfigRepository(options.api)

    Vue.mixin({
      filters: {
        formatDate: function (value) {
          if (!value) {
            return ''
          }

          return moment(value).format(config.getMomentDateFormat())
        }
      },

      computed: {
        dateFormat () {
          return config.getDateFormat()
        }
      }
    })
  }
}
export default LocalizationVuePlugin



// WEBPACK FOOTER //
// ./src/ui/LocalizationVuePlugin.js